import { render, staticRenderFns } from "./companyRevenue.vue?vue&type=template&id=7f65d1e1"
import script from "./companyRevenue.vue?vue&type=script&lang=js"
export * from "./companyRevenue.vue?vue&type=script&lang=js"
import style0 from "./companyRevenue.vue?vue&type=style&index=0&id=7f65d1e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports